/**************************************************
 * Nombre:       Home_Proposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from "../../../Recursos/fondo_seccion.svg";
import b from "../../../Recursos/b.svg";
import n from "../../../Recursos/n.svg";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Proposito = () => {
    const {masSM, sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', mb: 18}}
            >
                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 6}}>
                            <Typography sx={{fontSize: sCell ? 28 :  36, fontWeight: 600, textAlign: 'center', lineHeight: 1.1}}>
                                Tenemos un propósito
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}/>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 2}}>
                            <Typography sx={{fontSize: 15, fontWeight: 400, textAlign: 'center'}}>
                                Representa nuestra visión: conectar tecnología, activos reales y crecimiento acelerado
                                para transformar la forma en que se mueve y crea valor.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}/>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 6, ml: !masSM ? -4 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'center', mt: 7}}>
                                    <img src={b} width={70} height={'auto'}/>
                                </Grid>

                                <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 6}}>
                                            <Typography sx={{fontSize: 36, fontWeight: 600, textAlign: 'flex-start'}}>
                                                Bit
                                            </Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 8}}
                                              sx={{justifyContent: 'flex-start', mt: 2}}>
                                            <Typography sx={{fontSize: 13, fontWeight: 400, textAlign: 'flex-start'}}>
                                                Representa lo digital y la tecnología blockchain como base para transformar la
                                                economía.
                                            </Typography>
                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'center', mt: 7}}>
                                    <img src={n} width={90} height={'auto'}/>
                                </Grid>

                                <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 6}}>
                                            <Typography sx={{fontSize: 36, fontWeight: 600, textAlign: 'flex-start'}}>
                                                Nova
                                            </Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 8}}
                                              sx={{justifyContent: 'flex-start', mt: 2}}>
                                            <Typography sx={{fontSize: 13, fontWeight: 400, textAlign: 'flex-start'}}>
                                                Simboliza expansión, energía y crecimiento acelerado del patrimonio a través de
                                                activos digitales y físicos.
                                            </Typography>
                                        </Grid>

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>



                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Proposito    